














import Vue from "vue";

// Use data('Key') when you want to create a dataset-key. By doing so you ensure to only get properly
// namespaces keys.
const dataKey = (name: string) => `fdExpandTransition${name}`;

const addClass = ({ classList }: Element, className: string) => {
  if (classList.contains(className)) {
    return;
  }
  classList.add(className);
};

const removeClass = ({ classList }: Element, className: string) => {
  if (!classList.contains(className)) {
    return;
  }
  classList.remove(className);
};

export default Vue.extend({
  name: "ExpandTransition",
  methods: {
    beforeEnter(el: HTMLElement) {
      addClass(el, "collapse-transition");
      const style = window.getComputedStyle(el);
      el.dataset[dataKey("OldPaddingTop")] = style.paddingTop || undefined;
      el.dataset[dataKey("OldPaddingBottom")] =
        style.paddingBottom || undefined;
      el.style.height = "";
      el.style.paddingTop = "";
      el.style.paddingBottom = "";
    },

    enter(el: HTMLElement) {
      const style = window.getComputedStyle(el);
      el.dataset[dataKey("OldOverflow")] = style.overflow || undefined;
      if (el.scrollHeight !== 0) {
        el.style.height = el.scrollHeight + "px";
        el.style.paddingTop = el.dataset[dataKey("OldPaddingTop")] || null;
        el.style.paddingBottom =
          el.dataset[dataKey("OldPaddingBottom")] || null;
      } else {
        el.style.height = "";
        el.style.paddingTop = el.dataset[dataKey("OldPaddingTop")] || null;
        el.style.paddingBottom =
          el.dataset[dataKey("OldPaddingBottom")] || null;
      }
      el.style.overflow = "hidden";
    },

    afterEnter(el: HTMLElement) {
      removeClass(el, "collapse-transition");
      el.style.height = "";
      el.style.overflow = el.dataset[dataKey("OldOverflow")] || null;
    },

    beforeLeave(el: HTMLElement) {
      const style = window.getComputedStyle(el);
      el.dataset[dataKey("OldPaddingTop")] = style.paddingTop || undefined;
      el.dataset[dataKey("OldPaddingBottom")] =
        style.paddingBottom || undefined;
      el.dataset[dataKey("OldOverflow")] = style.overflow || undefined;

      el.style.height = el.scrollHeight + "px";
      el.style.overflow = "hidden";
    },

    leave(el: HTMLElement) {
      if (el.scrollHeight !== 0) {
        addClass(el, "collapse-transition");
        el.style.height = "0";
        el.style.paddingTop = "0";
        el.style.paddingBottom = "0";
      }
    },

    afterLeave(el: HTMLElement) {
      removeClass(el, "collapse-transition");
      el.style.height = "";
      el.style.overflow = el.dataset[dataKey("OldOverflow")] || null;
      el.style.paddingTop = el.dataset[dataKey("OldPaddingTop")] || null;
      el.style.paddingBottom = el.dataset[dataKey("OldPaddingBottom")] || null;
    }
  }
});
